import { render } from "./NoRecord.vue?vue&type=template&id=8583dce4&scoped=true&ts=true"
import script from "./NoRecord.vue?vue&type=script&lang=ts"
export * from "./NoRecord.vue?vue&type=script&lang=ts"

import "./NoRecord.vue?vue&type=style&index=0&id=8583dce4&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8583dce4"]])

export default __exports__